// src/features/bookings/components/BookingList/BookingFilters.jsx
import React from 'react';
import styles from './BookingFilters.module.css';
import Button from '../../../../shared/components/ui/Button';

const BOOKING_TYPES = [
  { value: 'graduation',        label: 'حفلات التخرج' },
  { value: 'wedding',           label: 'الأعراس' },
  { value: 'kids',              label: 'تصوير أطفال' },
  { value: 'event',             label: 'مناسبات' },
  { value: 'special',           label: 'طلب خاص' },
  { value: 'digital_marketing', label: 'تسويق إلكتروني' },
];

const STATUS_OPTIONS = [
  { value: 'active',      label: 'الحجوزات النشطة' },
  { value: 'all',         label: 'كل الحالات' },
  { value: 'pending',     label: 'قيد الانتظار' },
  { value: 'confirmed',   label: 'مؤكد' },
  { value: 'in_progress', label: 'قيد التنفيذ' },
  { value: 'completed',   label: 'مكتمل' },
  { value: 'cancelled',   label: 'ملغي' },
];

const BookingFilters = ({ filters, onChange, onClear, allowedBookingTypes }) => {
  const bookingTypes = allowedBookingTypes?.length ? allowedBookingTypes : BOOKING_TYPES;

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        <input
          type="text"
          name="client_name"
          placeholder="بحث باسم العميل..."
          value={filters.client_name}
          onChange={onChange}
        />
        <select name="booking_type" value={filters.booking_type} onChange={onChange}>
          <option value="">كل أنواع الحجوزات</option>
          {bookingTypes.map((t) => (
            <option key={t.value} value={t.value}>{t.label}</option>
          ))}
        </select>
        <select name="status" value={filters.status} onChange={onChange}>
          {STATUS_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
        <input
          type="date"
          name="start_date"
          value={filters.start_date}
          onChange={onChange}
          title="التاريخ من"
        />
        <input
          type="date"
          name="end_date"
          value={filters.end_date}
          onChange={onChange}
          title="التاريخ إلى"
        />
      </div>

      <div className={styles.footer}>
        <Button variant="secondary" size="sm" onClick={onClear} type="button">
          الرجوع للشهر الحالي
        </Button>
      </div>
    </div>
  );
};

export default BookingFilters;
